import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { DraftOrderPage, draftOrderQueryOptions } from '@/features/draft-orders';

export const Route = createFileRoute('/_authed/_active/s/$storeId/draft-orders/$draftId')({
  staticData: { tours: ['draft-orders.detail'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.read');
  },
  loader: async ({ context, params }) => {
    const draft = await context.queryClient.query({
      ...draftOrderQueryOptions(params.storeId, params.draftId),
      staleTime: 'static',
    });
    return { crumb: draft.name };
  },
  component: DraftOrderPage,
});
